if (typeof window.myObject === "undefined") {
    window.MarkdownPrice = {
        settings: [],
        expires: 14, // 14 days

        // Initialize a new markdown discount or update an existing one
        init: function (markdownSettings) {
            if (typeof markdownSettings !== "object") {
                console.error("Invalid markdown settings format.");
                return;
            }

            const existingIndex = this.settings.findIndex(setting => setting.id === markdownSettings.id);

            if (existingIndex !== -1) {
                this.settings[existingIndex] = markdownSettings; // Update existing markdown
                //console.log(`MarkdownPrice: Updated discount "${markdownSettings.discount_code}"`, markdownSettings);
            } else {
                this.settings.push(markdownSettings); // Add new markdown
                //console.log(`MarkdownPrice: Added new discount "${markdownSettings.discount_code}"`, markdownSettings);
                window.autoApplyCouponCode(markdownSettings.discount_code);
            }

            this.saveToCookie(this.expires); // Save updated settings to cookie

            /**
             * Sample Product
             */
            const products = [
                { name: "Duvet Cover", price: 100, collection: "duvet-cover", variant: "standard" },
                { name: "Pillowcase", price: 50, collection: "pillowcases", variant: "standard" },
                { name: "Sheet Set", price: 120, collection: "sheet-set", variant: "limited-edition" }
            ];
            if (products.length > 0) {
                const discountedProducts = this.run(products);
                //console.log("MarkdownPrice: Discounts applied automatically.", discountedProducts);
            }
        },
    
        // Remove a specific markdown by ID
        remove: function (id) {
            const index = this.settings.findIndex(setting => setting.id === id);

            if (index !== -1) {
                this.settings.splice(index, 1); // Remove discount
                this.saveToCookie(expires); // Update the cookie
                console.log(`MarkdownPrice: Removed discount with ID "${id}".`);
            } else {
                console.warn(`MarkdownPrice: No discount found with ID "${id}".`);
            }
        },
    
        // Clear all markdown discounts
        clear: function () {
            document.cookie = "markdown_object=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;"; // expire cookie date
            this.settings = []; // reset settings
            //console.log("MarkdownPrice: Cleared markdown_object cookie.");
        },
    
        // Save markdown settings to a cookie
        saveToCookie: function (expires = 14) {
            document.cookie = `markdown_object=${encodeURIComponent(JSON.stringify(this.settings))}; path=/; max-age=${60 * 60 * 24 * expires};`; // 14 days
            //console.log("MarkdownPrice: Saved settings to cookie.", this.settings);
        },
    
        // Load markdown settings from cookie
        loadFromCookie: function () {
            const cookieValue = document.cookie
                .split("; ")
                .find(row => row.startsWith("markdown_object="))
                ?.split("=")[1];

            if (cookieValue) {
                try {
                    this.settings = JSON.parse(decodeURIComponent(cookieValue));
                    //console.log("MarkdownPrice: Loaded settings from cookie.", this.settings);
                } catch (error) {
                    console.error("Failed to parse markdown_object cookie:", error);
                }
            }
        },
    
        // Run function to apply the best discount to a price list
        run: function (products) {
        return products.map(product => {
            let bestDiscountedPrice = product.price;
    
            this.settings.forEach(setting => {
            if (
                setting.collections.includes(product.collection) ||
                setting.specialVariants.includes(product.variant)
            ) {
                let discountValue = setting.specialVariants.includes(product.variant)
                ? setting.specialMultiplier
                : setting.multiplier;
    
                let discountedPrice = setting.subtract
                ? product.price - discountValue // Fixed dollar discount
                : product.price * discountValue; // Percentage discount
    
                if (discountedPrice < bestDiscountedPrice) {
                bestDiscountedPrice = discountedPrice;
                }
            }
            });
    
            //console.log(`Applied discount to ${product.name}: Original $${product.price}, New $${bestDiscountedPrice.toFixed(2)}`);
            
            this.loadFromCookie();
            
            return {
            ...product,
            discountedPrice: bestDiscountedPrice.toFixed(2)
            };
        });
        }
    };
}

function inIframe() {
	try {
		return window.self !== window.top;
	} catch (e) {
		return true;
	}
}


window.autoApplyCouponCode = function (discount_code = "", expires = 7) {
	const anchor = document.getElementById("markdown-anchor");
	if (inIframe()) {
		return;
	}
	const current_discount = Cookies.get("markdown_discount_code") || "";
	const markdowns = Cookies.getJSON("markdown_object") || [];
	const mardownsWithCode = markdowns.filter((x) => x.markdown_discount_code);
	const mardownCode = mardownsWithCode.length
		? mardownsWithCode[0].markdown_discount_code
		: "";
	const code = discount_code || mardownCode || current_discount;
	const applied_discount = Cookies.get("discount_code") || "";
	const code_applied = Cookies.get("discount_code_applied") === code;
	setCookieWithExpiry("markdown_discount_code", code, expires);

	if (!applied_discount || !code_applied || applied_discount !== code) {
		if (anchor) {
			const frame = document.createElement("iframe");
			frame.src = `https://miletomidnight.com/discount/${code}`;
			frame.style = "width:0;height:0;border:0;border:none;position:absolute;";
			anchor.innerHTML = "";
			anchor.appendChild(frame);
			setCookieWithExpiry("discount_code_applied", code, expires);
		}
	}
};

function setCookieWithExpiry(name, value, expires = 1.5) {
	return Cookies.set(name, value, { expires });
}

// Load markdown settings from cookie on page load
//window.MarkdownPrice.loadFromCookie();

// Initialize multiple markdown discounts with auto-run
/*
window.MarkdownPrice.init({
    discount_code: "Sale1",
    multiplier: 0.8, // 20% discount
    collections: ["duvet-cover", "duvet-set"],
    subtract: false,
    autoApplyCoupon: false,
    id: "sale1",
    specialVariants: ["limited-edition"],
    specialMultiplier: 1.5,
    scriptDiscountMessage: "Spring Sale! Extra Discounts Applied."
});
*/
/*
window.MarkdownPrice.init({
    discount_code: "TESTDIS25",
    multiplier: 0.75, // 25% discount
    collections: ["pillowcases"],
    subtract: false,
    autoApplyCoupon: false,
    id: "sale2",
    specialVariants: ["limited-edition"],
    specialMultiplier: 1.5,
    scriptDiscountMessage: "Spring Sale! Extra Discounts Applied."
});
*/
/*
window.MarkdownPrice.init({
    discount_code: "TESTDIS",
    multiplier: 0.75, // 25% discount
    collections: ["pillowcases"],
    subtract: false,
    autoApplyCoupon: false,
    id: "sale2",
    specialVariants: ["limited-edition"],
    specialMultiplier: 1.5,
    scriptDiscountMessage: "Spring Sale! Extra Discounts Applied."
});
*/